import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';

import { addMenuItemType, blockType } from '../../types/menus';
import { caption, divider } from './types';

export const useRenderBlocks = (blocksMap: Map<addMenuItemType, blockType[]>) => {
  const { t } = useTranslation();
  return useMemo(() => {
    const renderBlocks = [] as (blockType | caption | divider)[];

    blocksMap.forEach((value, key) => {
      if (value.length) {
        renderBlocks.push({ caption: t(`Lygo:${key}`) }, ...value, { divider: true });
      }
    });
    return renderBlocks;
  }, [blocksMap, t]);
};
